module.exports = __webpack_public_path__ + "img/star_line.7f498ac1.svg";